import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-multi-select-list',
  templateUrl: './multi-select-list.component.html',
  styleUrls: ['./multi-select-list.component.scss']
})
export class MultiSelectListComponent {
  
  @ViewChild('searchInput') searchInput ;

  @Input() checked = false;
  @Input() indeterminate = false;
  @Input() searchText = '';
  @Input() isMulti: boolean = false;

  @Output() readonly selectAllChange = new EventEmitter();
  @Output() readonly searchChange = new EventEmitter();

  constructor() {
    setTimeout(() => {
      this.searchInput.setFocus();
    },250);
  }
}
